import {getAccessToken} from "../components/lib/auth/getAccessToken.ts";

/**
 * Will build an header which can be sent to the backend server to authenticate.
 * 
 * @returns {Object} the authentication header with a
 * token when user is logged in
 */
export default async function  authHeader() {
    try {
        const token =  await getAccessToken();
        return { 'Authorization': 'Bearer ' +  token };
    } catch (error) {
        return {};
    }
}